<template>
  <div>
    <el-dialog :title="title" :visible.sync="isShowModal" :close-on-click-modal="false" width="900px"
               @close="closeDialog">
      <div style="text-align: right; position: absolute; top:20px; right: 100px;">
        <el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>
      </div>
      <div  style="width: 800px; height: 600px; overflow-y: scroll; border: 1px solid #ccc; margin: 0 auto;">
        <div id="printMe" style=" width: 700px; margin: 0 auto; height: 1000px;">
          <div class="stuBox" style="page-break-after:always;">
            <div class="cell-group Letter_to_parents">
              <div class="title font24 bloder textCenter">告家长书</div>
              <div class="">各学生及家长：</div>
              <div class="textIndent2">我校自成功创建江苏省四星级中等职业学校、江苏省优质特色职业学校以来，在各方面呈现出良好的发展态势。为了规范学校管理，提高管理质量和效能，现将学生统一着装和使用电子产品管理事宜告之如下：</div>
              <div class="font18 bloder">一、关于学生统一着装的规定</div>
              <div class="textIndent2">
                <span>为了规范学生的仪容仪表，展示学生精神面貌，我校规定：</span>
                <span class="bloder">学生在校期间一律按要求正确穿着校服、佩戴胸卡。</span>
              </div>

              <div class="font18 bloder">二、关于学生使用手机等电子产品管理的规定</div>
              <div class="textIndent2"> 随着科技进歩、社会发展致使学生越来越普遍使用手机进行资讯查阅、资料查阅、人际交往和自我表达，手机的使用一定程度上方便了学生与教师、家长和社会的沟通联系。但由于手机的娱乐功能和交际功能越来越丰富，以及学生心智还不成熟，部分自控力较弱的学生过度使用手机，沉迷于网络游戏和交友聊天，导致学习不专心、视力下降以及亲子关系紧张，严重影响正常的学习、生活和身心健康。</div>
              <div class="textIndent2">学校根据教育部办公厅教基厅函〔2021〕3号文件《关于加强中小学生手机管理工作的通知》、江苏省教育厅办公室苏教办基函〔2021〕8号文件《关于转发教育部办公厅加强中小学生手机管理工作的通知》、常熟市教育局常教转〔2021〕24号文件精神，要求我校学生原则上不得将个人手机带入学校。学生确有将手机带入校园需求的，须经学生家长同意、书面提出申请，进校后应将手机交由系部统一管理，禁止带入课堂。</div>
              <div class="textIndent2">请家长履行教育职责，让孩子科学、理性对待并合理使用手机，提高学生信息素养和自我管理能力，加强对孩子使用手机的督促管理，形成家校协同育人合力。</div>
              <div class="textIndent2 bloder">对确有需要将手机、mp3 、mp4等电子产品带来学校的，每日早读前学生将相关电子产品以班级为单位交至系部代保管，每日放学时领回。（若违反规定，一经发现，一概收缴）</div>
              <div class="textIndent2">对违规使用的手机、mp3、mp4等电子产品或电池充电器处理方法：</div>
              <div class="xuangua bloder">情形一：对违规使用手机等电子产品初犯者，能配合教职工收缴的，问题处理结束后一周，由本人提出书面申请，经班主任、系部同意后，可退还本人。</div>
              <div class="xuangua bloder">情形二：对违规使用手机等电子产品使用规定再犯者，问题处理结束后，需在一个月后，由本人提出书面申请，经班主任提出建议，系部同意后，家长来校领取。</div>
              <div class="xuangua bloder">情形三：对违规使用手机等电子产品屡教不改者，以书面的形式通知家长到校，提出整改意见，一学期结束后由学生家长来校领取。</div>
              <div class="xuangua bloder">另：对于部分违规使用且情节恶劣的学生，学校将视情节给予纪律处分！</div>
              <div class="flexEnd font18">常熟高新园中等专业学校</div>
              <div class="flexEnd font18">2021年5月</div>

            </div>

            <div class="table" style="margin-top: 20px;">
              <el-row class="cell borderR" style="font-weight: bold;">关于学生在校期间手机使用及穿着校服规定的反馈意见</el-row>
              <el-row class="borderR">
                <el-col :span="4" class="cell">系部</el-col>
                <el-col :span="4" class="cell">{{detailInfo.department}}</el-col>
                <el-col :span="4" class="cell">班级</el-col>
                <el-col :span="4" class="cell">{{detailInfo.class}}</el-col>
                <el-col :span="4" class="cell">学生姓名</el-col>
                <el-col :span="4" class="cell">{{baseInfo.stu_name}}</el-col>
              </el-row>

              <el-row class="flexStretch borderR borderB">
                <el-col :span="4" class="cell cell50 flexCenter" style="line-height: unset">以上规定<br/>我已阅读<br/>并遵守执行</el-col>
                <el-col :span="8">
                  <el-row class="cell">学生签名</el-row>
                  <el-row class="cellMore flexCenter">
                      <div class="flexCenter" v-if="detailInfo.signUrlStu" style="width: 100%;height: 130px;box-sizing:border-box;padding:1px;overflow: hidden">
                        <img v-if="detailInfo.signUrlStu" :src="detailInfo.signUrlStu" alt="" style="width: 100%;">
                      </div>
                  </el-row>
                </el-col>
                <el-col :span="4" class="cell cell50 flexCenter" style="line-height: unset">以上规定<br/>我已阅读<br/>并督促子女<br/>遵守执行</el-col>
                <el-col :span="8">
                  <el-row class="cell">家长签名</el-row>
                  <el-row class="cellMore flexCenter">
                    <div class="flexCenter" v-if="detailInfo.signUrlParent" style="width: 100%;height: 130px;box-sizing:border-box;padding:1px;overflow: hidden">
                      <img v-if="detailInfo.signUrlParent" :src="detailInfo.signUrlParent" alt="" style="width: 100%;">
                    </div>
                  </el-row>
                </el-col>
              </el-row>

            </div>
          </div>


        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>

export default {

  props: {
    detailInfo:{
      name: "",
      gender: 0
    },
    baseInfo:{
      type: Object,
      default:{},
    },
    dialogNum:0,
    title:'',
  },
  data() {
    return {
      isShowModal: true,
    }
  },
  mounted() {

  },
  methods: {
    closeDialog() {
      this.$parent.closePrint()
    }
  }
}
</script>

<style scoped="scoped" type="text/less" lang="less">
.Letter_to_parents{
  box-sizing: border-box;
  padding-top: 10px!important;
  font-size: 14px;
  .font16{font-size: 16px;}
  .font18{font-size: 18px;}
  .font20{font-size: 20px;}
  .font24{font-size: 24px;}
  .bloder{font-weight: 700}
  .textCenter{text-align: center}
  .textIndent2{text-indent:2em;}
  .xuangua{text-indent:-2em;padding-left:4em}
}

.flexStretch{
  display: flex;justify-content: flex-start;align-items: stretch;
}
.stuBox{
  box-sizing: border-box;
  padding-top: 20px;
  position: relative;
  .posIndex{
    position: absolute;
    top: 20px;
    right: 0px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #303133;
  }
  .table{
    width: 100%;
  }
  .borderR {border-right: 1px solid #333;}
  .borderB {border-bottom: 1px solid #333;}
  .FS18{
    font-size: 18px;
  }
  .bold{
    font-weight: 700;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }
  .cell{
    border-left: 1px solid #333;
    border-top: 1px solid #333;

    min-height: 30px;
    line-height: 30px;
    text-align: center;
    white-space: nowrap;
    font-size: 14px;
    font-family:"宋体";
  }
  .cell50{
    min-height: 50px;
    line-height: 50px;
    font-size: 14px;
    font-family:"宋体";
  }
  .cellMore{
    border-left: 1px solid #333;
    border-top: 1px solid #333;
    min-height: 50px;
    text-align: left;
    font-size: 14px;
    font-family:"宋体";
  }
}
.uline {
  text-decoration: underline;
}
</style>
